<template>
	<AppSubmenu class="layout-menu clearfix" :items="model" :layoutMode="layoutMode" :menuActive="active"
                :root="true" :parentMenuItemActive="true"/>
</template>

<script>
import AppSubmenu from './AppSubmenu';

export default {
	props: {
		layoutMode: String,
		active: Boolean
    },
    data() {
        return {
            model : [
				{ label: '主页', icon: 'pi pi-fw pi-home', to:'/' },
				{ label: '提案申请', icon: 'fa fa-fw fa-pencil-square-o', to:'/submission' },
				{ label: '提案查询', icon: 'pi pi-fw pi-search', to:'/query', visible: () => this.canRead },
				{ label: '提案审核', icon: 'pi pi-fw pi-check-circle', to:'/approval/toapproveall', visible: () => this.canApprove },
				{ 
					label: '管理', icon: 'pi pi-fw pi-cog', visible: () => this.isAdmin,
					items: [
						{ label: '用户权限', icon: 'fa fa-fw fa-user-o', to: '/usermanagement' },
						{ label: '通知公告', icon: 'fa fa-fw fa-comment-o', to: '/noticemanagement' },
					]
				},
				{ label: '关于', icon: 'pi pi-fw pi-info-circle', to:'/about' },
			]
        }
    },
	components: {
		'AppSubmenu': AppSubmenu
	},
	computed: {
		loggedIn() {
            return this.$store.state.authentication.status.loggedIn;
        },
        userInfo() {
            return this.$store.state.authentication.user;
		},
		canApprove() {
            return this.isPreapprover || this.isApprover;
        },
		canRead() {
            return this.isPreapprover || this.isApprover || this.isReader;
        },
        isPreapprover() {
			return this.$store.state.authentication.permissions.preapprover === true;
        },
        isApprover() {
			return this.$store.state.authentication.permissions.approver === true;
		},
		isReader() {
			return this.$store.state.authentication.permissions.reader === true;
		},
		isAdmin() {
			return this.$store.state.authentication.permissions.admin === true;
		},
    }
}
</script>

<style scoped>

</style>
